<template>
    <div class="text-xs-center">
        <h1 class="title">Incompatible</h1>
        <p class="subheading">
            This tool is only compatible with the Chrome web browser (Non-Windows).
        </p>
    </div>
</template>

<script>
export default {
  name: "incompatible-browser"
};
</script>
